export const toContactFormData = (contact, fileInfo) => {
  const {
    cellPhone,
    email,
    facebook,
    firstName,
    instagram,
    lastName,
    linkedin,
    phone,
    status,
    priority,
    birthday,
    partner,
    partnerBirthday,
    label,
    title,
    twitter,
    company,
    about,
    salutation,
    accountOwner,
    phoneExt,
    fax
  } = contact

  const { file, crop } = fileInfo
  const formData = new FormData()

  const contactData = {
    ...(cellPhone ? { cellPhone } : {}),
    ...(email ? { email } : {}),
    ...(facebook ? { facebook } : {}),
    ...(firstName ? { firstName } : {}),
    ...(instagram ? { instagram } : {}),
    ...(lastName ? { lastName } : {}),
    ...(linkedin ? { linkedin } : {}),
    ...(phone ? { phone } : {}),
    ...(status ? { statusId: status.value } : {}),
    ...(priority ? { priority: priority.value } : {}),
    ...(birthday ? { birthday } : {}),
    ...(partner ? { partner } : {}),
    ...(partnerBirthday ? { partnerBirthday } : {}),
    ...(label ? { label } : {}),
    ...(salutation ? { salutation: salutation.value } : {}),
    ...(accountOwner ? { accountOwner: accountOwner.value } : {}),
    ...(title ? { title } : {}),
    ...(phoneExt ? { phoneExt } : {}),
    ...(fax ? { fax } : {}),
    ...(twitter ? { twitter } : {}),
    ...(company ? { companyId: company.value } : {}),
    ...(about ? { about } : {})
  }

  formData.append('contactData', JSON.stringify(contactData))

  if (file) {
    formData.append('file', file)
    if (crop) {
      formData.append('cropX', crop.x)
      formData.append('cropY', crop.y)
      formData.append('cropWidth', crop.width)
      formData.append('cropHeight', crop.height)
    }
  }

  return formData
}

export const toContactsSelectValue = contacts =>
  contacts.map(contact => ({
    label: `${contact.firstName} ${contact.lastName}`,
    value: contact.id
  }))
